import { ThresholdProgressBar } from '@/common/ui/ThresholdProgressBar'

type CompanyStatsBlockPercentCellProps = {
    percent: number
    label: string
}

export const CompanyStatsBlockPercentCell = ({ percent, label }: CompanyStatsBlockPercentCellProps) => {
    const roundedPercent = Math.round(percent)

    return (
        <div className='flex items-center gap-2 min-w-[5.5rem]'>
            <ThresholdProgressBar
                value={percent}
                className='min-w-[2.5rem] flex-1'
                aria-label={`${label}: ${roundedPercent}%`}
            />
            <span className='text-xs tabular-nums text-base-content/80 shrink-0'>{roundedPercent}%</span>
        </div>
    )
}
